module.exports = __webpack_public_path__ + "img/tree-01-e-trunk.ffa880be.png";